import { SNS_ITEMS } from '@/constants/contact';

const SNS = () => {
  return (
    <div className='flex items-center gap-4 xl:gap-8'>
      {SNS_ITEMS.map((item, index) => {
        return (
          <div
            key={`SNS${index}`}
            className='w-auto h-auto flex flex-col justify-center items-center'
          >
            <div className='md:w-12 md:h-12 w-10 h-10 rounded-full flex justify-center items-center bg-[#4d5257]'>
              <a href={item.link} target='blank' className='w-6 h-6'>
                <img src={item.src} alt='' className='w-6 h-6' />
              </a>
            </div>
            <span className='hidden text-white'>{item.name}</span>
          </div>
        );
      })}
    </div>
  );
};

export default SNS;
